import { fetch } from "../services/api";
// import { get as apiBffGet } from "../services/api-bff";
import { unlock } from "./smartLocksActions";

// const identify = (hotelId, code) => {
//     console.log('3006 - IDENTIFY hotelId', hotelId)
//     console.log('3006 - IDENTIFY code', code)

//     return apiBffGet(`reservations/${code}`, true)
//         .then(async r => {
//             if (r.found) {
//                 console.log('0407 - R1', r)
//                 return apiBffGet(`checkins/current`, true).then(data => {
//                     console.log('0407 - R2', data)
//                     if (data.id) {
//                         console.log('0407 - data', data)
//                         // data['externalId'] = data['externalId'] || securityCode;
//                         data['inStay'] = false;
//                         if (data.status === 'in_stay' && data.roomOccupationId) {
//                             data['inStay'] = true; //_data.id
//                         }
//                         data['reservation'] = JSON.parse(data.reservation);
//                         data['email'] = data['email'] || '';
//                         data['travelType'] = data['travelType'] || '';
//                         data['extraData'] = data.extraData ? JSON.parse(data.extraData) : {};
//                         data['timestamp'] = Date.now();
//                         console.log('0407 - data', data)
//                         return data;
//                     }
//                     throw new Error('checkin-not-found')

//                     }
//                 )
//             }
//         })

//     // return fetch(checkInsByExternalId, { externalId: securityCode, filter: { hotelId: { eq: hotelId } } })
//     // // return fetch(checkInsBySecurityCode, { hotelId: hotelId, securityCode: { eq: securityCode } })
//     //         .then(r => {
//     //             console.log('2509 - r.data', r.data)
//     //             console.log('2509 - CheckInsByExternalId.items', r.data?.CheckInsByExternalId?.items?.length)
//     //             if (r.data?.CheckInsByExternalId?.items?.length === 1) {
//     //                 const _data = r.data.CheckInsByExternalId.items[0];
//     //                 console.log('2509 - _data', _data)
//     //                 _data['externalId'] = _data['externalId'] || securityCode;
//     //                 _data['inStay'] = false;
//     //                 if (_data.status === 'in_stay' && _data.roomOccupationId) {
//     //                     _data['inStay'] = true; //_data.id
//     //                 }
//     //                 _data['reservation'] = JSON.parse(_data.reservation);
//     //                 _data['email'] = _data['email'] || '';
//     //                 _data['travelType'] = _data['travelType'] || '';
//     //                 _data['extraData'] = _data.extraData ? JSON.parse(_data.extraData) : {};
//     //                 _data['timestamp'] = Date.now();
//     //                 console.log('2509 - _data', _data)
//     //                 return _data;
//     //             }
//     //             throw new Error('checkin-not-found')
//     //         })
// }

const refreshStatus = (hotelId, checkInId) => {
    if (!hotelId || !checkInId) return;

    console.log('TODO - refreshStatus')
    // return fetch(getCheckInStatus, { id: checkInId, hotelId: hotelId })
    //     .then(r => {
    //         if (r.data?.getCheckIn?.id) {
    //             const _newData = { ...r.data.getCheckIn }
    //             _newData['webCheckInDone'] = _newData['lastSentToReview'] ? true : false;
    //             delete _newData['lastSentToReview']
    //             const _data = { ..._newData, evolutions: [] };
    //             if (r.data?.CheckInEvolutionsByCheckInId?.items?.length > 0) {
    //                 _data['evolutions'] = r.data.CheckInEvolutionsByCheckInId.items;
    //             }
    //             return _data;
    //         }
    //         throw new Error('checkin-refresh-status-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const addComment = (hotelId, checkInId, comment) => {
    console.log('TODO - addComment')
    // return fetch(CheckInEvolution, {
    //     checkInId: checkInId,
    //     hotelId: hotelId,
    //     comment: comment
    // })
    //     .then(r => {
    //         if (r.data?.CheckInEvolution?.id) {
    //             return { id: r.data.CheckInEvolution.id, comment: comment };
    //         }
    //         throw new Error('checkin-add-comment-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const onChangeEvent = (checkInId, cb) => {
    console.log("16ago - events - checkInActions - onChangeEvent")
    console.log('TODO - onChangeEvent')
    // return fetch(onCheckInChange, { id: checkInId }).subscribe({
    //     next: (r) => {
    //         if (r.value?.data?.onCheckInChange) {
    //             cb(r.value.data.onCheckInChange)
    //         } else {
    //             console.error(r)
    //         }
    //     },
    //     error: (err) => console.error(err)
    // });
}

const save = (data) => {
    console.log('TODO - save')
    // return fetch(data.id ? updateCheckIn : createCheckIn, { input: { ...data } })
    //     .then(r => {
    //         if (r.data?.updateCheckIn?.id) {
    //             return r.data.updateCheckIn;
    //         }
    //         throw new Error('checkin-save-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const addEvolution = (hotelId, checkInId, status, comment = "") => {
    console.log('TODO - addEvolution')
    // return fetch(CheckInEvolution, {
    //     checkInId: checkInId,
    //     hotelId: hotelId,
    //     status: status,
    //     comment: comment
    // })
    //     .then(r => {
    //         console.log('RRR', r);
    //         if (r.data?.CheckInEvolution?.id) {
    //             return { id: r.data.CheckInEvolution.id, comment: comment };
    //         }
    //         throw new Error('checkin-add-comment-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const getRoomOccupationData = (roomOccupationId) => {
    console.log('TODO - getRoomOccupationData')
    // return fetch(getRoomOccupation, { id: roomOccupationId })
    //     .then(r => {
    //         if (r.data?.getRoomOccupation?.id) {
    //             console.log('1909 - getRoomOccupation', r.data.getRoomOccupation)
    //             return r.data.getRoomOccupation;
    //         }
    //         throw new Error('getStayData-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const addSubscriptionDevice = (checkInId, webPushId) => {
    console.log('TODO - checkInAddPushNotification')
    // return fetch(checkInAddPushNotification, { checkInId, webPushId })
    //     .then(r => {
    //         console.log('PUSH addSubscriptionDevice r', r)
    //         const rJson = JSON.parse(r?.data?.CheckInAddPushNotification)
    //         console.log('PUSH addSubscriptionDevice rJson', rJson?.body?.status?.checkIn?.subscriptions)
    //         if (rJson?.body?.status?.checkIn?.subscriptions) {
    //             return {
    //                 status: true,
    //                 subscriptions: rJson.body.status.checkIn.subscriptions
    //             }
    //         }
    //         throw new Error('addSubscriptionDevice-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //         throw new Error('addSubscriptionDevice-error')
    //     });
}

const getRoomCategoryByExternalId = (externalId) => {
    console.log('TODO - roomCategoryByExternalId')
    // return fetch(roomCategoryByExternalId, { externalId: externalId })
    //     .then(r => {
    //         if (r.data?.listRoomCategorys?.items?.length === 1) {
    //             return r.data.listRoomCategorys.items[0];
    //         }
    //         throw new Error('getRoomCategoryByExternalId-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const smartLockUnlock = (checkInId, smartLockId) => {
    return unlock(checkInId, smartLockId)
}
// API.graphql(graphqlOperation(checkInAddPushNotification, { checkInId, webPushId })).then((r) => {
//     if (r.data.CheckInAddPushNotification) {
//         const jJson = JSON.parse(r.data.CheckInAddPushNotification)
//         if (jJson.statusCode === 200) {
//             if (!subscriptions || (subscriptions.join('|') !== jJson.body.subscriptions.join('|'))) {
//                 console.log('GRABAR')
//                 dispatch(refreshSubscriptions(checkInId, jJson.body.subscriptions))
//             } else {
//                 console.log('NO GRABAR')
//             }
//         }
//     }
// });

const getBalance = (checkInId) => {
    if (!checkInId) return;
    console.log('TODO - getCheckInBalance')
    // return fetch(getCheckInBalance, { id: checkInId })
    //     .then(r => {
    //         if (r.data?.getCheckIn?.balance) {
    //             return JSON.parse(r.data.getCheckIn.balance);
    //         }
    //         throw new Error('checkin-getbalance-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const getBalancePaymentUrl = (hotelId, checkInId) => {
    console.log('TODO - partnersIntegration - balance-payment-button')
    // return fetch(partnersIntegration, {
    //     event: JSON.stringify({
    //         "partner": 'stripe',
    //         "entity": "payments",
    //         "action": "balance-payment-button",
    //         "hotelId": hotelId,
    //         "checkInId": checkInId
    //     })
    // }).then(r => {
    //     if (r.data?.PartnersIntegration?.data) {
    //         return r.data.PartnersIntegration.data;
    //     }
    // });
}

export {
    refreshStatus,
    addComment,
    addEvolution,
    save,
    onChangeEvent,
    getRoomOccupationData,
    addSubscriptionDevice,
    getRoomCategoryByExternalId,
    getBalance,
    getBalancePaymentUrl
}